export const buildQueryString = (params: Record<string, unknown>): string => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      searchParams.append(key, String(value));
    }
  }

  return searchParams.toString();
};

export const extractQueryParams = (paramsToExtract: string[]): Record<string, string | null> => {
  const queryParams = new URLSearchParams(window.location.search);
  const result: Record<string, string | null> = {};

  paramsToExtract.forEach((paramName) => {
    result[paramName] = queryParams.get(paramName);
  });

  return result;
};

export const addParamToUrl = (url: string, key: string, value: string): string => {
  const urlString = String(url);
  const urlWithProtocol =
    urlString.startsWith('http://') || urlString.startsWith('https://')
      ? urlString
      : `${window.location.origin}${urlString.startsWith('/') ? '' : '/'}${urlString}`;

  const urlObj = new URL(urlWithProtocol);
  urlObj.searchParams.set(key, value);
  return urlObj.toString();
};
